import Styles from './SelectImageContent.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props {
  imageUrl?: string
}

export const ConfirmImage = ({ imageUrl }: Props) => {
  return (
    <div className={Styles.confirmImageContainer}>
      <div className={Styles.confirmImage}>
        <Heading level={2}>Confirm image selection</Heading>
        <img src={imageUrl} alt="selected" />
      </div>
    </div>
  )
}
